// extracted by mini-css-extract-plugin
export default {"table":"Doc_table__q8-LF"};